import { createNamedApi } from '@essent/common';

import { GetOffersService } from './get-offers.service';

export const getOffersApi = createNamedApi(
  '[become-a-customer] Get Offers',
  GetOffersService
);
